import { Box, CircularProgress } from '@mui/material';

export default function CircularLoading({ label }) {
  return <Box display="flex"
    justifyContent="center"
    alignItems="center"> <CircularProgress /> </Box>
}
